import { graphql } from 'react-apollo';

import { compose, withProps } from 'recompose';

import user from 'js/lib/user';

import IsProgramAdmin from 'bundles/enterprise-admin/queries/IsProgramAdmin.graphql';
import type {
  IsProgramAdminQuery,
  IsProgramAdminQueryVariables,
} from 'bundles/enterprise-admin/queries/__generated__/IsProgramAdmin';
import type { EnterpriseProgramFromSlugFragment } from 'bundles/enterprise-legacy-learner-home/queries/__generated__/EnterpriseProgramBySlugQuery';

type PropsFromCaller = {
  program: EnterpriseProgramFromSlugFragment;
};

export type PropsFromWithEnterpriseAdminRoles = {
  isProgramAdmin: boolean;
  renderErrorPage: boolean;
};

type PropsFromWithProps = {
  userId: number;
};

const withEnterpriseAdminRoles = compose(
  withProps<PropsFromWithProps, {}>(() => ({
    userId: user.get().id,
  })),
  // IsProgramAdmin is a replacement for EnterpriseAdminRolesV1 used below
  // it currently accounts for Staff/Mentor roles
  graphql<
    PropsFromCaller & PropsFromWithProps,
    IsProgramAdminQuery,
    IsProgramAdminQueryVariables,
    PropsFromWithEnterpriseAdminRoles
  >(IsProgramAdmin, {
    options: ({ program }) => ({
      variables: { programId: program?.id },
      context: { clientName: 'gatewayGql' },
      skip: !user.isAuthenticatedUser() || !program,
      ssr: false, // same as below
    }),
    props: ({ data }) => {
      return {
        renderErrorPage: Boolean(data?.error),
        isProgramAdmin: Boolean(data?.EnterprisePermission?.queryIsProgramAdmin),
      };
    },
  })
);

export default withEnterpriseAdminRoles;
